import { render, staticRenderFns } from "./editIcon.vue?vue&type=template&id=5ece06e0&"
import script from "./editIcon.vue?vue&type=script&lang=js&"
export * from "./editIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports